import React, { useEffect, useState } from "react";
import axios from "axios";
import { InlineWidget } from "react-calendly";

// Import supabase configuration
import supabase from '../config/supabase';
import Header from "../components/header/clientHeader";
import { Buffer } from "buffer";
import Skeleton from "react-loading-skeleton";
import { Oval } from "react-loader-spinner";
import moment from "moment";
import Calendly from "../components/calendly/calendly";
import CalendlyCancel from "../components/calendly/calendlyCancel";
import { hotjar } from 'react-hotjar';
import mixpanel from 'mixpanel-browser';

// Import router from next
import { useNavigate } from "react-router-dom";

const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjI1ODE1MjAxLCJqdGkiOiI5ZjBlZTlhYy1lM2ZhLTQ1MjEtOWJjYy1mNDUxYjQ4MWQwN2YiLCJ1c2VyX3V1aWQiOiJGRERCUzVWTEhYNUJVV0JRIn0._pUHaYDAX5DhxDoGj4sV17CVRqv91p5rh3P53dleKdI'; 
function CalendlyPage() {

    const navigate = useNavigate();

	const [clientProfiles, setClientProfiles] = useState([]);
	const [notifications, setNotifications] = useState({});
	const [profile, setProfile] = useState({});
	const [showLoader, setShowLoader] = useState(true);
	const [urlWithToken, setUrlWithToken] = useState("");
	const [meetingScheduled, setMeetingScheduled] = useState(false);
	const [calendlyURL, setCalendlyURL] = useState('');

	useEffect(async () => {
		document.title = "Schedule interview";
		mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
		hotjar.initialize(2875931, 6);

		// Get profile id
		var profile_id = localStorage.getItem("clientBoardProfile");
		getProfileDetails(profile_id);
		getNotifications();
		localStorage.setItem("flag", true);

		const options = {
			method: 'GET',
			// url: 'https://v1.nocodeapi.com/needu531/calendly/UuhqsxSfkwhnndJA/invitees?uuid=de61489e-5eaa-41e0-bbd0-a2450bdaba20',
			url: 'https://api.calendly.com/scheduled_events/3491f2c6-094a-4df3-941b-b80ad47df67e/invitees',
			headers: {
				'Content-Type': 'application/json',
				Authorization: token
			}
		  };
		  
		  axios.request(options).then(function (response) {
			console.log(response.data);
		  }).catch(function (error) {
			console.error(error);
		  });
	}, []);

	useEffect( () => {
		var url = new URL(window.location.href);
		var calendly = url.searchParams.get("calendlyUrl");
		calendly = Buffer.from(calendly || "", "base64").toString("utf-8");
		setCalendlyURL(calendly);
	},[]);

	const getClient = async(check) => {
		// get client invitation id
		var url = new URL(window.location.href);
		var clientInvitationId = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(clientInvitationId || "", "base64").toString("utf-8");
		
		if(client_invitation_id)
		{
			if(check == "profiles"){
				var client = await getclientProfiles(client_invitation_id, "profiles");
				setClientProfiles(client.profiles);
				return {
					'profiles' : client.profiles,
					'clientId' : client_invitation_id,
					"clientEmail" : client.email,
				}
			}
			else{
				const url = await getclientProfiles(client_invitation_id, "url");
				return url
			}
		}
	}

	async function fetchDateTime(e) {
		// Get profile id
		setMeetingScheduled(true);
		setShowLoader(true);
		var profile_id = localStorage.getItem("clientBoardProfile");

		var client = await getClient("profiles");

		var profile = await getProfileDetails(profile_id);
	
		await axios.get(e.event.uri, { headers: { Authorization: token }})
			.then(function (response) {

				console.log(response)
				// handle success
				if(response.data.resource.start_time){
					mixpanel.track('meetingScheduled', {
						'profileName': profile.full_name,
						"meetingTime" : response.data.resource.start_time,
						'clientEmail' : client.clientEmail,
					  });
					var alreadyLoggedIn = localStorage.getItem("supabase.auth.token") || "";
					if(alreadyLoggedIn){
						updateMeetingTime(response.data.resource.start_time,response.data.resource.end_time, client.profiles,client.clientId,profile_id,profile)
						
					}
				}
			})
			.catch(function (error) {
			})
	}

	async function updateMeetingTime(startTime, endTime,tempClientProfiles,clientId,profileId,profile){
		tempClientProfiles.forEach((profile)=>{
			if(profile.id == profileId){
				profile.meetingTime = startTime;
				profile.endMeetingTime = endTime;
			}
		})
		setClientProfiles(tempClientProfiles);
		setMeetingScheduled(true);

		var { data, error } = await supabase
        .from("board_clients_invitation")
        .update({profiles: tempClientProfiles})
        .match({ id: clientId });

		if(data && data.length){

			let date  = new Date(startTime);
			var start = moment(date).format('MMMM Do, h:mm A') ;

			// End meeting time
			let endDate  = endTime && new Date(endTime);
			var end = endDate ? moment(endDate).format('h:mm A') : "";

			var name = profile.full_name ? profile.full_name.split(" ")[0] : "Akira";
			var message = "You have scheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
			await insertNotifications(clientId,message);
		}
	}

	const insertNotifications = async(clientId,message) => {
		// localStorage.removeItem("flag");

		var profile_id = localStorage.getItem("clientBoardProfile");

		var { data, error } = await supabase
		.from("notifications")
		.select("*")
		.match({client: clientId, message: message,profileId:profile_id})

		if(data && data.length <= 0){
			let flag = localStorage.getItem("flag");
			if(flag == "true"){
				localStorage.removeItem("flag");
				var { data, error } = await supabase
				.from("notifications")
				.insert({client: clientId, message: message,profileId:profile_id})
		
				if(data && data.length){
					localStorage.setItem("showNumber",true);
					await getNotifications();
					setShowLoader(false);
				}
			}else{
				await getNotifications();
				setShowLoader(false);
			}
		}
	}

	const getclientProfiles = async(id, check) => {
		var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ id: id });

      if (data && data.length) {
		  setUrlWithToken(data[0].url_with_token);
		  if(check == "profiles"){
			return {
				'profiles':data[0].profiles,
				'email': data[0].email,
			}
		  }
		  else{
			return data[0].url_with_token;
		  }
      }
	}

	async function getNotifications(){
		var url = new URL(window.location.href);
		var clientInvitationId = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(clientInvitationId || "", "base64").toString("utf-8");

		var { data, error } = await supabase
        .from("notifications")
        .select("*")
		.order('created_at', { ascending: false })
        .match({client: client_invitation_id});

		if(data && data.length){
          let meetings = data;
          meetings.map((m,index)=> {
            let date  = m.created_at && new Date(m.created_at);
			let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
            var end = newDate ? moment(newDate).format('h:mm A') : "";
            m.time = end;
            var today = new Date();
            var yesterday = new Date(today);

            yesterday.setDate(yesterday.getDate() - 1);

            var checkDay = new Date(today);

            checkDay.setDate(checkDay.getDate() - 6);

            if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
              m.day = "Today"
            }
            else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
              m.day = "Yesterday"
            }
            else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
              var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var d =days[date.getDay()];
  
              m.day = d ;
            }
            else{
              m.day = moment(date).format('MMM Do');
            }
          })
         
          setNotifications(meetings);
        }
		// setMeetingScheduled(true);
	}

	async function getProfileDetails(profileId){
		var { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .match({ id: profileId });

		setShowLoader(false);

		if (data && data.length) {
			setProfile(data[0]);
			return data[0]
		}
	}
	

	async function toCandidates(){
		mixpanel.track('toOtherCandidates');

		if(urlWithToken){
			localStorage.removeItem("loggedIn");
			const url = urlWithToken.split("client")[1];
			navigate(`/client${url}`);
		}
		else{
			var url = new URL(window.location.href);
			var clientInvitationId = url.searchParams.get("client");
			
			if(clientInvitationId){
				localStorage.removeItem("loggedIn");
				url = await getClient("url");
				url = url.split("client")[1];
				navigate(`/client${url}`);
			}
			else{
				url = window.location.href.split("board")[1];
				navigate(`/client?id${url}`);
			}
		}
		
	} 

	return (
		<div className="w-full ">

			{/* Add header */}
			<Header justView={localStorage.getItem("supabase.auth.token") ? false : true} showLogin={localStorage.getItem("supabase.auth.token") ? false : true} getClient={getClient} notifications={notifications}>

			{showLoader && (
				<div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
				{/* Add backdrop */}
				
				<div className={`relative flex`}>
					<Oval
						color="white"
						secondaryColor="grey"
						height="40"
						width="60"
					/>
					<div className="flex items-center">Hold Tight-just getting this page ready.</div>
				</div>
				</div>
			)}
				<div className="grid grid-cols-12 gap-0 sticky">
					<div className="col-span-8 pt-10 h-full">
						<CalendlyCancel onSchedule={fetchDateTime} calendlyURL={calendlyURL} />
					</div>
					
					<div className="col-span-4 bg-blue-7 relative">
						<div className="flex flex-col items-center justify-center pt-28">
							{/* Show image */}
							<img src="/calendly.png" className="" />
							{/* Show text */}
							{
								meetingScheduled ? <div className="font-bold text-center mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
									Your meeting has been scheduled with {profile.full_name}'s recruiting manager
							</div> :
								<div className="font-bold text-center mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
								{`Enter details and request a meeting with ${profile.full_name ? profile.full_name.split(" ")[0] : "Akira"}'s recruitment manager`}
							</div>
							}
							
							<div className="absolute -left-10 mb-28">
								<img src="/arrow.png" />
							</div>

							{/* Add card */}
							<div className={`grid grid-cols-12 gap-3 border-blue-4 border-2 shadow-calendlyProfileCard bg-white-1 px-7 py-5 mx-7 ${meetingScheduled ? "mt-16" : "mt-8"} mb-5 rounded-md`}>
								<div className="col-span-3 mt-3">
									{
										showLoader ? <div>
											<Skeleton height={90} width={90} />
										</div>
										// Render imgae
										: profile.emoji_dp ? <div className="w-20 h-20 -ml-4 -mt-2">
											<img className="" src={profile.emoji_url} />
										</div> : (
											// Render placeholder
											<div className="w-16 h-16 bg-white-3 flex items-center">
											{/* Render text */}
											<div className="text-center w-full text-md font-text text-white-1 font-medium">
												{profile.full_name && profile.full_name[0].toUpperCase()}
											</div>
											</div>
										)
									}
								</div>
								
								<div className="col-span-9 grid grid-cols-12 gap-0">
									{
										showLoader ? <div className="col-span-12 ml-4">
										<div><Skeleton height={30} width={130} /></div>
										<div className="mt-2"><Skeleton height={20} width={130} /></div>
										<div className="mt-2"><Skeleton height={20} width={130} /></div>
										<div className="mt-2"><Skeleton height={25} width={130} /></div>
										
								</div>
								: <div className="col-span-12 grid grid-cols-12 gap-0">
									
									{/* Render name */}
									<div className="col-span-12 text-lg text-black-1 font-normal mb-2">
										{profile.full_name}
									</div>

									{/* Render location */}
									{profile.location ? (
									<div className="col-span-12 mb-2 text-sm font-light text-black-1 flex items-center">
										{/* Icon */}
										<img className="mr-1 h-4 " src="/location_icon2.svg" alt="Avatar" />

										{/* Text */}
										{profile.location} 
									</div>
									) : null}

									{/* Render timezone */}
									{profile.timezone ? <div className="col-span-12 text-sm font-light flex mb-4" >
										<svg className="mt-0.5 h-4 w-4 ml-0.5 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"/></svg>
										{profile.timezone.split(" ")[0].replace(/[\(\)]/g, "")}
									</div>
									: null}

									{/* Show skills */}
									<div className="col-span-12 flex flex-wrap">
										{/* Render tags */}
										{(profile && profile.skill_level) ? profile.skill_level.length > 0 && profile.skill_level.length > 3
											? profile.skill_level.slice(0,3).map((element, index) => (
												<div
												key={index}
												className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
												>
												{element.skill}
												</div>
											))
											: profile.skill_level.map((element, index) => (
												<div
												key={index}
												className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
												>
												{element.skill}
												</div>
											))
											: null}
									</div>
								</div>
								}

								</div>
							</div>

							{
								meetingScheduled ? <div className="pb-10" onClick={() => toCandidates()}>
									<div className="font-semibold flex items-center text-white-1 mt-20 p-4 rounded cursor-pointer text-sm bg-pink-1">View other candidates </div> </div>
							 : 
							<div className="font-semibold flex text-pink-1 mt-20 cursor-pointer " onClick={() => toCandidates()}>View other candidates 
								<svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgba(255, 73, 116, 1)"/></svg>
							</div>
							}
							
						</div>
					</div>
				</div>
			</Header>
			
		</div>
	);
};

export default CalendlyPage;